export const eventsRoutes = {
  details: ":id",
  edit: ":id/edit",
  create: "new",
} as const;
